export enum State {
    Custom,
    Earth,
    Traversing,
    Waiting,
    WaitingInteractively,
}
